<template>
  <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content">
                    <div class="item">
                        <div id="leftPanel">
                            
                            <TopBar/>
                            <div id="mainMenuSelected">SEND MESSAGE</div>
                            <p class="infoOption">Please select a message type:</p>
                            <MainMenu
                                
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two">
            <div class="outer">
                <div class="content middle">
                    <div class="p15">
                        
                        <Logo />
                        <div class="content-two">
                            <p class="sub-title">READY FOR PICK UP!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../store'
import TopBar from '../components/TopBar.vue'
import MainMenu from '../components/MainMenu.vue'
import Logo from '../components/Logo'
export default {
    props:[],
    components: {
        TopBar,
        MainMenu,
        Logo
    },
    created(){
      
    }
}
</script>

<style>

</style>